import { render } from "./HeaderDropdownAvatar.vue?vue&type=template&id=1bf0dd67&scoped=true&ts=true"
import script from "./HeaderDropdownAvatar.vue?vue&type=script&lang=ts"
export * from "./HeaderDropdownAvatar.vue?vue&type=script&lang=ts"

import "./HeaderDropdownAvatar.vue?vue&type=style&index=0&id=1bf0dd67&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bf0dd67"],['__file',"src/components/HeaderDropdownAvatar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1bf0dd67"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1bf0dd67', __exports__)) {
    api.reload('1bf0dd67', __exports__)
  }
  
  module.hot.accept("./HeaderDropdownAvatar.vue?vue&type=template&id=1bf0dd67&scoped=true&ts=true", () => {
    api.rerender('1bf0dd67', render)
  })

}


export default __exports__